import { makeStyles } from '@material-ui/core'

import palette from 'theme/palette'

const styles = makeStyles(() => ({
  text: {
    color: palette.secondary.main,
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    fontWeight: 500,
  },
  loadingTextTransition: {
    transition: 'opacity 0.5s',
    opacity: 1,
  },
  fadeEnter: {
    opacity: 0,
  },
  fadeEnterActive: {
    opacity: 1,
    transition: 'opacity 0.5s',
  },
  fadeExit: {
    opacity: 1,
  },
  fadeExitActive: {
    opacity: 0,
    transition: 'opacity 0.5s',
  },
  skeletonWave: {
    backgroundColor: palette.dai.lightBlue,
    transition: 'background-color 0.5s',
  },
  daiStarIcon: {
    color: palette.dai.main,
    display: 'block',
    transformBox: 'fill-box',
    transformOrigin: 'center',
    willChange: 'transform',
    animation: '$daiStarLoading 1.1s ease-in-out infinite',
  },
  '@keyframes daiStarLoading': {
    '0%': { transform: 'rotate(0deg) scale(1)' },
    '50%': { transform: 'rotate(180deg) scale(1.35)' },
    '100%': { transform: 'rotate(360deg) scale(1)' },
  },
}))

export default styles
